$(function () {
    $('select:not(.no-ready)').chosen();
});
